/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import { getTopicFormat } from '@braindate/domain/lib/topic/util';
import messages from 'src/shared/domain/topic/l10n/topicL10n';

import SecondaryTag from 'src/shared/ui/component/data-display/SecondaryTag';
import useFeatureDecisions from 'src/shared/app/feature/hook/useFeatureDecisions';

import styles from './DetailedTopicCard.style';
import InfoIcon from 'src/shared/ui/component/icon/InfoIcon';

import type { Topic } from '@braindate/domain/lib/topic/type';

type Props = {
  topic: Topic,
};

const useStyles = createUseThemeStyles(styles);

const TopicFormatTag = ({ topic }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const topicFormat = getTopicFormat(topic);
  const { isConversationFormatEnabled } = useFeatureDecisions();

  React.useEffect(() => {
    ReactTooltip.rebuild();
  });

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */
  if (!isConversationFormatEnabled || !topicFormat) return null;

  return (
    <SecondaryTag
      tooltip={intl.formatMessage(messages[`${topicFormat}Tooltip`])}
    >
      {intl.formatMessage(messages[topicFormat])}
      <InfoIcon className={classes.infoIcon} />
    </SecondaryTag>
  );
};

export default React.memo<Props>(TopicFormatTag);
